@if (renderDescription) {
  <sidebar-title-description
    [description]="sidebarElement().guidelineCriteria.description"
    [showDescription]="sidebarElement().showDescription"
    [title]="sidebarElement().guidelineCriteria.title"
    (descriptionChange)="onDescriptionChanged($event)"
    (showDescriptionChange)="onShowDescriptionChange($event)"
    (titleChange)="onTitleChanged($event)" />
}

<tt-divider class="tt-guideline-sidebar_divider" />

<tt-guideline-component-sidebar-basics
  [attachments]="sidebarElement().attachments ?? []"
  [links]="sidebarElement().links ?? []"
  [references]="sidebarElement().references ?? []"
  [resourceTags]="sidebarElement().resourceTags ?? []"
  (basicsChanged)="handleBasicsChanged($event)" />

<tt-divider class="tt-guideline-sidebar_divider" />

@if (hasColorPresets()) {
  <div class="tt-guideline-sidebar_color-preset">
    <span>{{ 'Color' | transloco }}:</span>
    <tt-customisable-flowchart-element
      [colorPresets]="colorPresets()"
      [flowchartNodeConfig]="flowchartNodeConfig()"
      (colorPresetChanged)="onColorPresetChanged($event)" />
  </div>

  <tt-divider class="tt-guideline-sidebar_divider" />
}

@if (!sidebarElement().guidelineAction) {
  <div class="tt-finding-tab_actions">
    <button
      aria-label="Add action button"
      class="tt-finding-tab_actions-add-action"
      emphasis="minimal"
      ttButton
      variant="primary"
      (click)="enableSearch($event)">
      <mat-icon [icon]="'plus'" [iconSize]="14" />
      {{ 'AddAction' | transloco }}
    </button>
  </div>
}
